import { Component, Fragment, h, Host, Prop } from '@stencil/core';
import { appRouter } from '../../../global';

@Component({
  tag: 'entry-the-developer-and-the-ai',
  styleUrl: 'component.css',
  assetsDirs: ['../assets'],
  shadow: true,
})
export class EntryTheDeveloperAndTheAiPage {

  @Prop({ reflect: true }) summary: boolean = false;

  render() {
    return <Host class="article"
      {...(this.summary && appRouter.click.theDeveloperAndTheAi())}
    >
      <div class="heading content box">
        <h2>The Dev and the AI</h2>
        <time>2 Feb 2024</time>
      </div>

      <div class="body content">
        <blockquote class="hero-background">
          <p>
            So, it's been a few weeks since I left my last contract, and while I am waiting for the Bat Signal, I am investigating Rust.
          </p>

          <p>
            I have been a C#/TS developer forever and although I've briefly put on some Java pants, I've not really changed much.
          </p>
        </blockquote>
      </div>

      {this.summary
        ? <div class="body content box">
          <noscript class="right"><a {...appRouter.href.theDeveloperAndTheAi()}>read more &hellip;</a></noscript>
        </div>
        : this.renderMore()}

    </Host>;
  }

  renderMore() {

    return <Fragment>
      <section>
        <div class="body content">
          <p>
            Rust is great, its a memory safe, cross-platform, compile to machine code language so its fast, you can write code for Windows, MacOS, Linux and others ... and WebAssembly which means it can run in a browser! oh my.
          </p>
          <p>
            Thing is, it's hard to get started on your own with a new language, and in the past this has been a blocker for me. I want to move on to the "biz" logic which is the interesting bit, and this is where AI comes in.
          </p>
          <p>
            <a href="https://www.theregister.com/2024/01/24/willison_ai_software_development">
              "Code Assistance [AI] is like having a weird intern who memorized the docs"
            </a>
          </p>
          <p>
            I've got a few on staff
            <ul>
              <li>GitHub CoPilot</li>
              <li>Bing CoPilot</li>
              <li>Bard</li>
            </ul>
          </p>
          <p>
            Generally it goes like this..
          </p>
          <div class="code">
            <div>
              <span class="line-number">10</span> <span class="keyword">REM</span> <span class="comment">plan what I want to do, which patterns to use</span>
            </div>
            <div>
              <span class="line-number">20</span> <span class="keyword">REM</span> <span class="comment">ask on of the interns, perhap provide a C# example</span>
            </div>
            <div>
              <span class="line-number">30</span> <span class="keyword">REM</span> <span class="comment">pick throught the response, visit recommended websites, try and work out what it should be, add my own bit</span>
            </div>
            <div>
              <span class="line-number">40</span> <span class="keyword">COMPILE</span> <span class="var">C</span>
            </div>
            <div>
              <span class="line-number">50</span> <span class="keyword">IF</span> <span class="var">C</span> <span class="operator">=</span> <span class="literal">9</span> <span class="keyword">THEN</span> <span class="literal">70</span>
            </div>
            <div>
              <span class="line-number">60</span> <span class="keyword">REM</span> <span class="comment">find out the intern is halucinating?</span>
            </div>
            <div>
              <span class="line-number">70</span> <span class="keyword">INPUT</span> <span class="literal">"Tired? Hungry?"</span> <span class="var">Q</span>
            </div>
            <div>
              <span class="line-number">80</span> <span class="keyword">IF</span> <span class="var">Q</span> <span class="operator">=</span> <span class="literal">"Y"</span> <span class="keyword">THEN END</span>
            </div>
            <div>
              <span class="line-number">90</span> <span class="keyword">GOTO</span> <span class="literal">20</span>
            </div>
          </div>

          <p>
            Anyway, overall I have to say that AI coding assistants are fun and helpful.
          </p>
          <p>
            Learning the basics of Rust has opened a world up to me that I will be exploring for a while more, without help I would never have done.
          </p>
          <p>
            It brings down the barriers of syntax and means that a developer, is a developer ... with a experience in certain languages, yes ... but a developer none the less.
          </p>
          <p>
            The important bit of being a programmer is to be able apply appropriate patterns and techniques to solve problems.
          </p>
          <p>
            Like being human is the same no matter what language we speak. (are you slowly standing and beginning to clap yet? Do it, before some else does!)
          </p>
        </div>

        <div class="body content">
          <p class="text-right">This entry was posted on <a href="https://www.linkedin.com/feed/update/urn:li:activity:7158500931720957952">LinkedIn</a></p>
        </div>

        <div class="body content">
          <img class="hero" src="/assets/robot.webp" width="1024" height="688" title="AI Image. A happy and slightly manic steampunk robot leaning in so its face is forward. Lots of neon, bulbs and LEDs. The robot has a metal body with gears, pipes, and wires. Its eyes are glowing with different colors and its mouth is wide open with a grin. The background is dark and smoky, with sparks and steam coming out of the robot's head." />
        </div>
      </section>
    </Fragment>
  }
}
